import { LabelGenerator } from '../../types';
export const isFesterAnlagebetrag: LabelGenerator = (product) =>
  product.product_type !== 'TERM' && !product.conditions.top_up.enabled && 'FesterAnlagebetrag';
